export const withFallback = <T>(
  array: T[] | undefined,
  fallbackLength: number
): (T | undefined)[] => {
  if (!array || array.length === 0) {
    return new Array(fallbackLength).fill(undefined);
  }
  return array;
};
